// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

import cautionImg from "src/assets/images/operating-manual/appendix-a/caution.png";
import manufacturerImg from "src/assets/images/operating-manual/appendix-a/manufacturer.png";

type AppendixAType = {
  title: string;
};

const AppendixA = ({ title }: AppendixAType) => {
  const { t } = useTranslation("operating-manual");
  const theme = useTheme();

  // invert the caution icon color in dark mode
  const symbolFilter = theme.palette.mode === "dark" ? "invert(1)" : "none";

  return (
    <OperatingManualContent title={title}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          mx: "20px",
        }}
      >
        <Grid container spacing="20px">
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <img
                src={cautionImg}
                width="30px"
                alt="caution"
                style={{ filter: symbolFilter }}
              />
              {t("Caution")}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <img src={manufacturerImg} width="30px" alt="manufacturer" />
              {t("Manufacturer")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </OperatingManualContent>
  );
};

export default AppendixA;
